/**
 * @file src/api/vendor.api.js
 * @description Purchase vendor API calls. Real endpoints (mounted under
 * /purchases on the backend). Company is resolved server-side from context.
 *
 * Endpoints:
 *  GET    /purchases/vendors            → list
 *  POST   /purchases/vendors            → create
 *  GET    /purchases/vendors/:id        → detail
 *  PATCH  /purchases/vendors/:id        → update
 *  DELETE /purchases/vendors/:id        → soft-delete
 *  GET    /purchases/vendors/:id/ledger  → AP statement
 *  GET    /purchases/vendors/:id/balance → AP balance
 */

import { apiClient } from "lib/axios";

const normalizeVendor = (vendor) => {
  if (!vendor) return vendor;
  return {
    ...vendor,
    id: vendor.id || vendor._id,
  };
};

const normalizeVendorListResponse = (data) => {
  const vendors = data?.vendors || data?.data?.vendors || data?.data || [];
  return {
    ...data,
    vendors: Array.isArray(vendors) ? vendors.map(normalizeVendor) : [],
  };
};

export const getVendors = async (params = {}) => {
  const { data } = await apiClient.get("/purchases/vendors", { params });
  return normalizeVendorListResponse(data);
};

export const getVendorById = async (vendorId) => {
  const { data } = await apiClient.get(`/purchases/vendors/${vendorId}`);
  return data;
};

export const createVendor = async (body) => {
  const { data } = await apiClient.post("/purchases/vendors", body);
  return data;
};

export const updateVendor = async (vendorId, body) => {
  const { data } = await apiClient.patch(
    `/purchases/vendors/${vendorId}`,
    body,
  );
  return data;
};

export const deleteVendor = async (vendorId) => {
  const { data } = await apiClient.delete(`/purchases/vendors/${vendorId}`);
  return data;
};

export const getVendorLedger = async (vendorId, params = {}) => {
  const { data } = await apiClient.get(
    `/purchases/vendors/${vendorId}/ledger`,
    { params },
  );
  return data;
};

export const getVendorBalance = async (vendorId, params = {}) => {
  const { data } = await apiClient.get(
    `/purchases/vendors/${vendorId}/balance`,
    { params },
  );
  return data;
};
